import * as React from "react";
import SigmaModal from "security-app/components/SigmaRules/ImportRulesModal/SigmaModal";
import { useGetSigmaRule } from "security-app/hooks/useSigmaAPI";
import { ConfirmDialog } from "security-app/components/common/Modal";
function CoreSigmaModal({ ruleId, onConfirm, onCancel }) {
  const { rule, loadingRule } = useGetSigmaRule(ruleId);
  if (!rule && !loadingRule) {
    return /* @__PURE__ */ React.createElement(
      ConfirmDialog,
      {
        show: true,
        onConfirm: onCancel,
        confirmText: "Close",
        noCancelButton: true,
        type: "danger",
        title: "Edit Sigma Event Definition"
      },
      /* @__PURE__ */ React.createElement("p", null, 'A Sigma Rule with ID: "', ruleId, '" could not be found.')
    );
  }
  return loadingRule ? null : /* @__PURE__ */ React.createElement(SigmaModal, { rule, onConfirm, onCancel });
}
export default CoreSigmaModal;
